import React from 'react';

const HOVER_LINE = 'rgb(99 102 241)';
const HOVER_GLOW = 'rgb(99 102 241)';

type ChartHoverHighlightProps = {
  x: number;
  height: number;
  dots?: Array<{ y: number; fill?: string }>;
};

/** Cross-chart synced hover — indigo bar + dots, high contrast on all three dashboards. */
const ChartHoverHighlight: React.FC<ChartHoverHighlightProps> = ({ x, height, dots = [] }) => {
  return (
    <>
      <line
        x1={x}
        y1={0}
        x2={x}
        y2={height}
        stroke={HOVER_GLOW}
        strokeWidth="4"
        strokeOpacity="0.18"
        vectorEffect="non-scaling-stroke"
      />
      <line
        x1={x}
        y1={0}
        x2={x}
        y2={height}
        stroke={HOVER_LINE}
        strokeWidth="2"
        strokeOpacity="0.92"
        vectorEffect="non-scaling-stroke"
      />
      {dots.map((dot, i) => (
        <circle
          key={`hover-dot-${i}`}
          cx={x}
          cy={dot.y}
          r={5}
          fill={dot.fill ?? HOVER_LINE}
          stroke="white"
          strokeWidth="2"
          vectorEffect="non-scaling-stroke"
        />
      ))}
    </>
  );
};

export default ChartHoverHighlight;
